import { DefaultPrimaryButton, DefaultSecondaryButton, Spinner } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { DetailCard } from '../../components/detail-card.component';
import { KioskNavigationFooter } from '../../components/kiosk-navigation-footer.component';
import { KioskNavigationHeader } from '../../components/kiosk-navigation-header.component';
import ProcessOpenCloseSlots from '../../components/slot-open-displays/process-open-close-slots/process-open-close-slots.component';
import { useMoveConfirm } from './move-confirm.controller';

const ID = 'move-confirm';

const MoveConfirm = () => {
    const viewProps = useMoveConfirm();

    if (viewProps.phase === 'opening') {
        return (
            <div
                id={ID}
                className='bg-background-default flex size-full flex-col overflow-hidden'>
                <KioskNavigationHeader title={CommonMessage.DETAIL.MANAGE(CommonMessage.OBJECTS.SPOT.DISTRI_SPOT)} />
                <div className='flex flex-1 flex-col overflow-hidden'>
                    <ProcessOpenCloseSlots
                        packages={viewProps.openingPackages}
                        onContinue={viewProps.handleOpeningContinue}
                    />
                </div>
            </div>
        );
    }

    return (
        <div
            id={ID}
            className='bg-background-default flex size-full flex-col overflow-hidden'>
            <KioskNavigationHeader
                title={CommonMessage.DETAIL.MANAGE(CommonMessage.OBJECTS.SPOT.DISTRI_SPOT)}
                onBack={viewProps.handleBack}
            />

            <div className='flex flex-1 flex-col gap-4 overflow-y-auto p-6'>
                {viewProps.isLoading && (
                    <div className='flex flex-1 items-center justify-center'>
                        <Spinner />
                    </div>
                )}
                {!viewProps.isLoading && viewProps.error && <div className='text-status-danger'>{viewProps.error}</div>}
                {!viewProps.isLoading && !viewProps.error && (
                    <>
                        <p className='text-foreground-default text-lg font-semibold'>
                            <FormattedMessage
                                id='kiosk.manage-spot.move-transaction.confirm.title'
                                defaultMessage='Confirm move'
                                description='Title on the manage-spot move transaction confirmation screen'
                            />
                        </p>
                        <DetailCard title={null}>
                            <DetailCard.Row
                                label={CommonMessage.OBJECTS.TRANSACTION.TRACKING_NUMBER}
                                value={viewProps.trackingNumber}
                            />
                            <DetailCard.Row
                                label={CommonMessage.OBJECTS.SPOT.DISTRI_SPOT}
                                value={viewProps.destinationSpot?.name ?? '/'}
                            />
                            <DetailCard.Row
                                label={CommonMessage.OBJECTS.SLOT.DEFAULT}
                                value={viewProps.destinationSlot?.display ?? viewProps.destinationSlot?.number ?? '/'}
                            />
                        </DetailCard>
                    </>
                )}
            </div>

            <KioskNavigationFooter
                leftButton={
                    <DefaultSecondaryButton
                        text={CommonMessage.BUTTONS.GO_BACK}
                        onClick={viewProps.handleBack}
                        disabled={viewProps.isSubmitting}
                    />
                }
                rightButton={
                    <DefaultPrimaryButton
                        text={CommonMessage.BUTTONS.CONFIRM}
                        onClick={viewProps.handleConfirm}
                        disabled={!viewProps.canConfirm}
                        isLoading={viewProps.isSubmitting}
                    />
                }
            />
        </div>
    );
};

export default MoveConfirm;
